import { render, staticRenderFns } from "./NotFoundCard.vue?vue&type=template&id=778a111f&"
import script from "./NotFoundCard.vue?vue&type=script&lang=js&"
export * from "./NotFoundCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports